import _extends from "@babel/runtime-corejs3/helpers/esm/extends";
import BrowserProtocol from 'farce/BrowserProtocol';
import createInitialFarceRouter from './createInitialFarceRouter';
import resolver from './resolver';
export default function createInitialBrowserRouter(options) {
  return createInitialFarceRouter(_extends({}, options, {
    historyProtocol: new BrowserProtocol(),
    resolver: resolver
  }));
}